export default __webpack_public_path__ + "locales/el-GR/ConvertDialog.json?hash=336b09b129a852a970accbcf6efd7c58";